import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ScheduleResponse } from '../shared/interfaces/schedule-reponse.model';
import { PublicService } from '../shared/services/public.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit, OnDestroy {

  private subscription: Subscription;

  scheduleResponseData!: ScheduleResponse;

  constructor(
    private publicService: PublicService,
  ) {
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.listenPublicScheduleSuccess();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private listenPublicScheduleSuccess(): void {
    this.subscription.add(
      this.publicService.onPublicScheduleSuccessData
        .subscribe(result => {
            this.scheduleResponseData = result;
        })
    );
  }

  getClinicAddressFormated(): string {
    return this.publicService.generateFormatedAddress(
      this.scheduleResponseData.clinic.address
    );
  }

  getScheduleTypeName(): string {
    return this.publicService.getTypeDescriptionByName(
      this.scheduleResponseData.schedule_type.name
    )
  }

  onNewScheduleClick(): void {
    this.publicService.navigateToClinicsPage();
  }
}
